import CounterUp from "./counterup";

export default function Milestone() {
  return (
    <div className="relative block w-full py-[40px] bg-[radial-gradient(113.98%_566.82%_at_-11.35%_1.51%,_#0F002E_0%,_#421A75_100%)] lg:after:content-[''] lg:after:absolute lg:after:bg-white/10 lg:after:w-full lg:after:h-[1px] lg:after:block lg:after:top-[110px] lg:after:left-0">
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="grid grid-cols-2">
          <div className="px-[10px] pb-[18px] lg:border-r lg:border-0 border-b border-solid border-white/10 2xl:w-1/4	">
            <div className="text-[42px] font-semibold bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent text-center flex justify-center gap-2">
              <CounterUp start="0" end="10" /> +
            </div>
            <h3 className="text-base leading-5 font-normal text-white px-3 text-center">
              Years of <br/>Experience
            </h3>
          </div>
          <div className="px-[10px] pb-[18px] lg:border-r lg:border-0 border-b border-solid border-white/10 2xl:w-1/4	">
            <div className="text-[42px] font-semibold bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent text-center flex justify-center gap-2">
              <CounterUp start="0" end="100" /> +
            </div>
            <h3 className="text-base leading-5 font-normal text-white px-3 text-center">
              Apps <br /> Launched
            </h3>
          </div>
          <div className="px-[10px] pt-[18px] 2xl:w-1/4	">
            <div className="text-[42px] font-semibold bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent text-center flex justify-center gap-2">
              <CounterUp start="0" end="100" /> %
            </div>
            <h3 className="text-base leading-5 font-normal text-white px-3 text-center">
              On-Time <br /> Delivery
            </h3>
          </div>
          <div className="px-[10px] pt-[18px] 2xl:w-1/4	">
            <div className="text-[42px] font-semibold bg-[linear-gradient(269.02deg,#FF37EB_25.44%,#9A4AFF_64%)] bg-clip-text text-transparent text-center flex justify-center gap-2">
              <CounterUp start="0" end="100" /> %
            </div>
            <h3 className="text-base leading-5 font-normal text-white px-3 text-center">
              Confidentiality <br/>Guaranteed
            </h3>
          </div>
        </div>
      </div>
      <div className="absolute 2xl:bottom-[-34px] lg:bottom-[-30px] z-[1] xl:block hidden">
        <img src="https://glocify.com/images/union-blue.svg" alt="union" />
      </div>
    </div>
  );
}
